import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useLanguage, useT } from '../../i18n';

export function LandingFooter() {
  const t = useT();
  const { lang, setLang } = useLanguage();

  return (
    <Box component="footer" sx={{ bgcolor: 'background.paper', borderTop: 1, borderColor: 'divider', py: 3 }}>
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="caption" color="text.secondary">
            {t('landing.footer.rights')}
          </Typography>
          <Stack direction="row" spacing={1} alignItems="center">
            <Button size="small" color="inherit" sx={{ color: 'text.secondary' }} component={Link} to="/login">
              {t('landing.nav.login')}
            </Button>
            <Button
              size="small"
              color="inherit"
              sx={{ color: 'text.secondary', minWidth: 0, px: 1 }}
              onClick={() => setLang(lang === 'id' ? 'en' : 'id')}
              aria-label="Switch language"
            >
              {lang === 'id' ? 'EN' : 'ID'}
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
